module.exports = __webpack_public_path__ + "img/spacing-height-01.fa6bf527.svg";